module.exports = __webpack_public_path__ + "img/sv24.bebad754.svg";